import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { AffiliateRequestStatusEnum } from '../../../../../modules/affiliates/affiliates-requests/enums/affiliate-request-status.enum';
import { AFFILIATE_REQUESTS_STATUS_TRANSLATIONS } from '../../../../services/data/data-constants-translations';
import { AFFILIATE_REQUEST_STATUSES } from '../../../../services/data/data-service.interface';

@Component({
  selector: 'gtd-ui-field-affiliate-request-status',
  templateUrl: './affiliate-request-status.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AffiliateRequestStatusComponent {
  @Input() customClass = '';

  @Input() set data(value) {
    switch (value) {
      case AffiliateRequestStatusEnum.REQUESTED:
        this.status = AFFILIATE_REQUESTS_STATUS_TRANSLATIONS[AFFILIATE_REQUEST_STATUSES.REQUESTED];
        break;
      case AffiliateRequestStatusEnum.APPROVED:
        this.status = AFFILIATE_REQUESTS_STATUS_TRANSLATIONS[AFFILIATE_REQUEST_STATUSES.APPROVED];
        break;
      case AffiliateRequestStatusEnum.DECLINED:
        this.status = AFFILIATE_REQUESTS_STATUS_TRANSLATIONS[AFFILIATE_REQUEST_STATUSES.DECLINED];
        break;
      default:
        this.status = 'Unknown';
    }
  }

  public status: string;
  public statusTranslations = AFFILIATE_REQUESTS_STATUS_TRANSLATIONS;
  public AFFILIATE_REQUEST_STATUSES = AFFILIATE_REQUEST_STATUSES;
}
